import BaseComponent from "@js/components/base_component.jsx";

import EuiRoutesIndexTable from "@js/components/eui/routes/index_table.jsx";

class EuiRoutesIndex extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      q: props.q,
    };
  }

  render() {
    const table = this.props.routes;

    return (
      <div>
        <div className="row">
          <div className="col-sm-offset-0 col-sm-8">
            {this.props.q &&
              I18n.t("phrases.showing_search_results_for_q", {
                q: this.props.q
              })}
          </div>
          <div className="col-sm-4">
            <form method="GET" onSubmit={ this._onSearch }>
              <div className="input-group">
                <span className="input-with-clear-icon">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={ I18n.t("phrases.search_routes") }
                    onChange={ e => this.setState({ q: e.target.value }) }
                    defaultValue={ this.props.q }
                  />
                  {
                    this.state.q &&
                      <span onClick={ this._onClearSearch }>&times;</span>
                  }
                </span>
                <span className="input-group-btn">
                  <button type="submit" className="btn btn-primary">
                    <i className="fa fa-search" />
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
        <br />

        <Panel heading="routes">
          <EuiRoutesIndexTable
            table={ table && table.data }
          />
          {table && table.total > 0 && <Paginator entity={table} />}
        </Panel>

      </div>
    );
  }

  _onClearSearch(e) {
    e.preventDefault();
    Turbolinks.visit(Routes.eui_routes_path());
  }

  _onSearch(e) {
    e.preventDefault();
    Turbolinks.visit(Routes.eui_routes_path({ q: this.state.q }));
  }

}

export default EuiRoutesIndex;
